import { createRouter, createWebHistory } from "vue-router"; // Import createWebHistory
import HomeView from "../views/HomeView.vue";
import ContactsView from "../views/Contacts.vue";
import AboutCyprusView from "../views/AboutCyprus.vue";
import PrivacyPolicyView from "../views/PrivacyPolicy.vue";
import CarsView from "@/views/CarsView.vue";
import CarRequestView from "@/views/CarRequestView.vue";
import ReviewsView from "@/views/ReviewsView.vue";
import TermsView from "@/views/TermsView.vue";
import CookiesView from "@/views/CookiesView.vue";
import FAQView from "@/views/FAQView.vue"; // Import the FAQ view

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Rent a Car in Cyprus | Affordable Rentals",
      description:
        "Discover affordable car rentals in Cyprus. Explore Paphos and Larnaca with our wide range of vehicles.",
      keywords: "Car rental, Cyprus, Paphos, Larnaca, affordable rentals",
    },
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: ContactsView,
    meta: {
      title: "Contact Us | Rent a Car in Cyprus",
      description:
        "Get in touch with us for any inquiries regarding car rentals in Paphos and Larnaca.",
      keywords: "Contact, Car rental, Cyprus",
    },
  },
  {
    path: "/cars",
    name: "Cars",
    component: CarsView,
    meta: {
      title: "Available Cars for Rent in Cyprus",
      description:
        "Browse our selection of cars available for rent in Paphos and Larnaca. Find the perfect vehicle for your trip.",
      keywords: "Car rentals, Cars for rent, Paphos, Larnaca",
    },
  },
  {
    path: "/about-cypr",
    name: "About Cyprus",
    component: AboutCyprusView,
    meta: {
      title: "About Cyprus | Your Car Rental Partner",
      description:
        "Learn more about Cyprus and our car rental services. Explore the beauty of the island with us.",
      keywords: "About Cyprus, Car rental, Cyprus",
    },
  },
  {
    path: "/reviews",
    name: "Reviews",
    component: ReviewsView,
    meta: {
      title: "Customer Reviews | Rent a Car in Cyprus",
      description:
        "Read what our customers say about our car rental services in Paphos and Larnaca.",
      keywords: "Customer reviews, Car rental, Cyprus",
    },
  },
  {
    path: "/privacy",
    name: "Privacy Policy",
    component: PrivacyPolicyView,
    meta: {
      title: "Privacy Policy | Rent a Car in Cyprus",
      description:
        "Understand how we collect and use your information when you rent a car from us.",
      keywords: "Privacy policy, Car rental, Cyprus",
    },
  },
  {
    path: "/terms",
    name: "Terms of Service",
    component: TermsView,
    meta: {
      title: "Terms of Service | Rent a Car in Cyprus",
      description: "Read our terms and conditions for renting a car in Cyprus.",
      keywords: "Terms of service, Car rental, Cyprus",
    },
  },
  {
    path: "/faq",
    name: "FAQ",
    component: FAQView,
    meta: {
      title: "Frequently Asked Questions | Rent a Car in Cyprus",
      description:
        "Find answers to the most common questions about our car rental services.",
      keywords: "FAQ, Car rental, Cyprus",
    },
  },
  {
    path: "/cookies",
    name: "Cookies Policy",
    component: CookiesView,
    meta: {
      title: "Cookies Policy | Rent a Car in Cyprus",
      description:
        "Learn about our cookies policy and how we use cookies on our website.",
      keywords: "Cookies policy, Car rental, Cyprus",
    },
  },
  {
    path: "/carrequest",
    name: "CarRequestView",
    component: CarRequestView,
    meta: {
      title: "Request a Car Rental | Rent a Car in Cyprus",
      description:
        "Fill out the form to request a car rental in Paphos or Larnaca.",
      keywords: "Car request, Car rental, Cyprus",
    },
  },
];

const router = createRouter({
  history: createWebHistory(), // Use createWebHistory for history mode
  routes,
});

export default router;
